export default __webpack_public_path__ + "static/media/icon_close.a8e32126.svg";